export function isLastIdentity(item) {
  if (item.is_last != null) return Number(item.is_last) === 1
  // Compatibility for an older tree response without is_last.
  return !Array.isArray(item.children) || item.children.length === 0
}

export function normalizeIdentityTree(nodes) {
  return (Array.isArray(nodes) ? nodes : []).map((item) => {
    const node = { ...item }
    // Element UI's non-lazy cascader treats even children: [] as a branch.
    if (isLastIdentity(node)) delete node.children
    else node.children = normalizeIdentityTree(node.children)
    return node
  })
}
